import actions from 'src/modules/appUser/view/appUserViewActions';

const initialData = {
  loading: false,
  record: null,
  error: null,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.FIND_STARTED) {
    return {
      ...state,
      record: null,
      loading: true,
      error: null,
    };
  }

  if (type === actions.FIND_SUCCESS) {
    return {
      ...state,
      record: payload,
      loading: false,
      error: null,
    };
  }

  if (type === actions.FIND_ERROR) {
    return {
      ...state,
      record: null,
      loading: false,
      error: payload || { status: 500 },
    };
  }

  return state;
};
